import React from 'react';

const Settings: React.FC = () => {
    return (
        <div>
            <h1>Settings</h1>
        </div>
    )
}

export default Settings;